import interceptedAxios from '../../../utils/interceptedAxios'

export interface AlarmData {
  alarmLabelId: string
  alarmLowerLimitLabelName: string
  urgentAlerts: number
  highAlerts: number
  lowAlerts: number
  assetIds: string[]
  cimCodeIds: string[]
  assetTypeIds: string[]
  deviceIds: string[]
}

export function fetchAlamHealthSummary (
  siteId: string, asseIds: string, deviceIds: string,
  onSuccess: (metadata: AlarmData, httpStatus: number) => void,
  onFailure: (errorMessage: any, httpStatus: number) => void
): void {
  const url = `/alarm-service/api/v1/udp/tiq/assets/alerts/healthSummary/${siteId}?assetIds=${asseIds}&deviceIds=${deviceIds}`
  interceptedAxios
    .get(url, { timeout: 15000 })
    .then((response) => {
      const responseData = response.data
      if (responseData.error === false) {
        if (responseData.data !== null && responseData.data !== undefined) {
          onSuccess(responseData.data, responseData.http_status)
        } else {
          onFailure(responseData.error, responseData.http_status)
        }
      } else {
        onFailure(responseData.error_message, response.status)
      }
    })
    .catch((error) => {
      if (error.response !== undefined) {
        onFailure(
          error.response.data !== undefined && error.response.data !== null
            ? error.response.data.error_message
            : 'Network Error',
          error.response.status
        )
      } else {
        onFailure('Network Error', 404)
      }
    })
}
